import { AxiosResponse } from "axios";
import {
  KulionerEntites,
  Kulioner,
  KulionerOrder,
  KulionerProduct,
  KulionerHistory
} from "@/domain/entities/Kulioner";
import { PaginationV2 } from "@/domain/entities/Pagination";

export class KulionerMapper {
  private _mapKulionerOrderEntities(order: any) {
    const productArr = order.ko_product ?? [];
    const histories = order.ko_histories ?? [];
    return new KulionerOrder({
      koId: order.ko_id,
      koStatus: order.ko_status,
      koOrderId: order.ko_order_id,
      koOrderShipmentId: order.ko_order_shipment_id,
      koOrderSttNo: order.ko_order_stt_no,
      koIsMarkProcessed: order.ko_is_mark_processed || false,
      koCreatedAt: order.ko_created_at,
      koUpdatedAt: order.ko_updated_at,
      koTotalProduct: order.ko_total_product,
      koTotalQuantity: order.ko_total_quantity || 0,
      koMerchantName: order.ko_merchant_name,
      koMerchantPhoneNumber: order.ko_merchant_phone_number,
      koMerchantAddress: order.ko_merchant_address,
      koMerchantLatlon: order.ko_merchant_lat_lon,
      koProductType: order.ko_product_type,
      koTotalPrice: order.ko_total_price,
      koRecipientPhoneNumber: order.ko_recipient_phone_number,
      koRecipientName: order.ko_recipient_name,
      koRecipientAddress: order.ko_recipient_address,
      koProduct: productArr.map((product: any) => {
        return new KulionerProduct({
          kodId: product.kod_id,
          kodProductName: product.kod_product_name,
          kodTotalPrice: product.kod_total_price,
          kodQuantity: product.kod_quantity,
          kodProductThumbnail: product.kod_product_thumbnail,
          kodPrice: product.kod_price
        });
      }),
      koHistories: histories.map((history: any) => {
        return new KulionerHistory({
          kohId: history.koh_id,
          kohStatus: history.koh_status,
          kohCreatedAt: history.koh_created_at,
          kohCreatedBy: history.koh_created_by
        });
      })
    });
  }

  convertKulionerListFromApi(res: AxiosResponse<any>) {
    const {data: { data }} = res;
    const ordersArr = data.order ?? [];
    return new KulionerEntites({
      pagination: new PaginationV2({
        allTotalData: data.meta.total_records,
        page: data.meta.page,
        limit: data.meta.limit,
        totalData: data.meta.total_records
      }),
      data: new Kulioner({
        summary: data.summary,
        order: ordersArr.map((order: any) => {
          return this._mapKulionerOrderEntities(order);
        })
      })
    });
  }

  convertKulionerDetailFromApi(res: AxiosResponse<any>) {
    const {
      data: { data }
    } = res;
    return this._mapKulionerOrderEntities(data);
  }

  convertKulionerListSummaryFromApi(res: AxiosResponse<any>) {
    const {data: { data }} = res;
    const item = data ?? []
    const countStatus = {} as any
    item.forEach((item: any) => {
      countStatus[item.status] = item.total
    })
    return countStatus
  }
}
